var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.2915 5.5C2.03837 5.5 1.83317 5.70521 1.83317 5.95834V9.16667C1.83317 9.4198 2.03837 9.625 2.2915 9.625H8.70817C8.9613 9.625 9.1665 9.4198 9.1665 9.16667V5.95834C9.1665 5.70521 8.9613 5.5 8.70817 5.5H2.2915ZM0.916504 5.95834C0.916504 5.19894 1.53211 4.58334 2.2915 4.58334H8.70817C9.46756 4.58334 10.0832 5.19894 10.0832 5.95834V9.16667C10.0832 9.92606 9.46756 10.5417 8.70817 10.5417H2.2915C1.53211 10.5417 0.916504 9.92606 0.916504 9.16667V5.95834Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 1.375C5.01377 1.375 4.54745 1.56816 4.20364 1.91197C3.85982 2.25579 3.66667 2.72211 3.66667 3.20834V5.04167C3.66667 5.2948 3.46146 5.5 3.20833 5.5C2.9552 5.5 2.75 5.2948 2.75 5.04167V3.20834C2.75 2.47899 3.03973 1.77952 3.55546 1.26379C4.07118 0.748067 4.77065 0.458336 5.5 0.458336C6.22935 0.458336 6.92882 0.748067 7.44454 1.26379C7.96027 1.77952 8.25 2.47899 8.25 3.20834V5.04167C8.25 5.2948 8.0448 5.5 7.79167 5.5C7.53854 5.5 7.33333 5.2948 7.33333 5.04167V3.20834C7.33333 2.72211 7.14018 2.25579 6.79636 1.91197C6.45255 1.56816 5.98623 1.375 5.5 1.375Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.e235faa23b92720252d8aac4497d71ed.svg";
export { ForwardRef as ReactComponent };